function AWS() {
    return (
        <>
        <div className="AWS">
            <h1>Coming Soon<span className="dots"></span></h1>
        </div>
        </>
    );
}

export default AWS;